import { render } from "./consideracion.vue?vue&type=template&id=1e5bee12"
import script from "./consideracion.vue?vue&type=script&lang=js"
export * from "./consideracion.vue?vue&type=script&lang=js"

import "./consideracion.vue?vue&type=style&index=0&id=1e5bee12&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__